module.exports = __webpack_public_path__ + "img/avatar_placeholder.5a4c8241.png";